(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-reef-searches"] && !Shopify.designMode) return;
  try {
    
(function () {
  function hydrate(card) {
    var media = card.querySelector('[data-prs-media]');
    if (!media || media.getAttribute('data-prs-hydrated')) return;
    var src = media.getAttribute('data-src');
    if (src) {
      var img = document.createElement('img');
      img.className = 'prs-card__img';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.setAttribute('fetchpriority', 'low');
      var srcset = media.getAttribute('data-srcset');
      if (srcset) img.srcset = srcset;
      var sizes = media.getAttribute('data-sizes');
      if (sizes) img.sizes = sizes;
      img.alt = media.getAttribute('data-alt') || '';
      img.src = src;
      var lift = media.querySelector('.prs-card__lift') || media;
      lift.appendChild(img);
    }
    media.setAttribute('data-prs-hydrated', '1');
  }

  function initPRS(root) {
    if (!root || root.__prsInit) return;
    root.__prsInit = true;
    var toggle = root.querySelector('[data-prs-toggle]');
    if (!toggle) return;
    var labelEl = toggle.querySelector('[data-prs-toggle-label]');
    var toggleItem = root.querySelector('[data-prs-toggle-item]');
    var collapsedText = toggle.getAttribute('data-collapsed');
    var expandedText = toggle.getAttribute('data-expanded');
    var keepBtn = toggle.getAttribute('data-keep') === '1';

    toggle.addEventListener('click', function () {
      var expanded = root.classList.toggle('prs--expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (expanded) {
        var extras = root.querySelectorAll('.prs-card--extra');
        for (var i = 0; i < extras.length; i++) hydrate(extras[i]);
        if (labelEl && expandedText) labelEl.textContent = expandedText;
        if (!keepBtn && toggleItem) toggleItem.setAttribute('hidden', '');
      } else if (labelEl && collapsedText) {
        labelEl.textContent = collapsedText;
      }
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.prs[data-prs]');
    for (var i = 0; i < nodes.length; i++) initPRS(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topshelf-subcollection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function hydrate(card) {
    var media = card.querySelector('[data-tsfg-media]');
    if (!media || media.getAttribute('data-tsfg-hydrated')) return;
    var src = media.getAttribute('data-src');
    if (src) {
      var img = document.createElement('img');
      img.className = 'tsfg-card__img';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.setAttribute('fetchpriority', 'low');
      var srcset = media.getAttribute('data-srcset');
      if (srcset) img.srcset = srcset;
      var sizes = media.getAttribute('data-sizes');
      if (sizes) img.sizes = sizes;
      img.alt = media.getAttribute('data-alt') || '';
      img.src = src;
      (media.querySelector('.tsfg-card__lift') || media).appendChild(img);
    }
    media.setAttribute('data-tsfg-hydrated', '1');
  }

  function init(root) {
    if (!root || root.__tsfgInit) return;
    root.__tsfgInit = true;
    var toggle = root.querySelector('[data-tsfg-toggle]');
    if (!toggle) return;
    var label = toggle.querySelector('[data-tsfg-toggle-label]');
    var collapsedText = toggle.getAttribute('data-collapsed');
    var expandedText = toggle.getAttribute('data-expanded');

    toggle.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (expanded) {
        var extras = root.querySelectorAll('.tsfg-card--extra');
        for (var i = 0; i < extras.length; i++) hydrate(extras[i]);
      }
      if (label) label.textContent = expanded ? expandedText : collapsedText;
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.tsfg[data-tsfg]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
